import {NgFor, NgIf} from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output
} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {Q9HtmlDecoderPipe, DialogWidth} from '@q9elements/ui-kit/common';
import {SelectModule} from '@q9elements/ui-kit/components';
import {PopupManagerService} from '../../../core/services/popup-manager.service';
import {Theme} from '../../../diagram-data/diagram-meta.interface';
import {ChangeDiagramThemeComponent} from '../../dialogs/change-diagram-theme/change-diagram-theme.component';
import {DiagramJSON} from '../../../shared/models/diagram-json.interface';

@Component({
  selector: 'app-theme-list',
  templateUrl: './theme-list.component.html',
  styleUrls: ['./theme-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgFor, TranslateModule, NgIf, SelectModule, Q9HtmlDecoderPipe]
})
export class ThemeListComponent implements OnInit, OnChanges {
  @Input() disabled: boolean;
  @Input() diagramJson: DiagramJSON;
  @Input() diagramThemes: Theme[];
  @Output() themeChanged = new EventEmitter<any>();
  theme = new UntypedFormControl();
  lastPickedTheme: Theme;

  constructor(
    private translateSvc: TranslateService,
    private popupSvc: PopupManagerService
  ) {}

  ngOnInit() {
    this.updateFormControl();
  }

  ngOnChanges() {
    this.updateFormControl();
  }

  openThemePopUp(pickedTheme: Theme) {
    const initialPickedName = pickedTheme.name;

    pickedTheme.name = this.translateSvc.instant('ASIDE_R.SWITCHING_THEME');
    this.theme.patchValue(pickedTheme);
    const passedObject = {
      passedThemeId: pickedTheme.id,
      diagramId: this.diagramJson.diagramId
    };

    setTimeout(() => {
      const dialogRef = this.popupSvc.open(ChangeDiagramThemeComponent, {
        data: passedObject,
        width: DialogWidth.SM,
        panelClass: ['q9-dialog']
      });

      dialogRef.afterClosed().subscribe(success => {
        if (success) {
          pickedTheme.name = initialPickedName;
          this.theme.patchValue(pickedTheme);
          this.themeChanged.emit(true);
        } else {
          pickedTheme.name = initialPickedName;
          this.theme.patchValue(this.lastPickedTheme);
        }
      });
    }, 0);
  }

  get startTheme(): Theme {
    return this.diagramThemes.find(theme => {
      return theme.id === this.diagramJson.theme.id;
    });
  }

  private updateFormControl() {
    this.theme.setValue(this.startTheme);

    if (this.disabled) {
      this.theme.disable({emitEvent: false});
    } else {
      this.theme.enable({emitEvent: false});
    }

    this.lastPickedTheme = this.startTheme;
  }
}
